import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import {useTranslation} from "react-i18next";

function CartAmountField({ className, type, disabled, onBlur, defaultValue }) {
	const [value, setValue] = useState(defaultValue);
	const { t } = useTranslation();

	useEffect(() => {
		setValue(defaultValue);
	}, [defaultValue]);

	return (
		<TextField
			className={className}
			type={type}
			placeholder={t('AMOUNT')}
			disabled={disabled}
			onBlur={onBlur}
			value={value}
			onChange={e => {
				const val = e.currentTarget.value;
				setValue(val);
			}}
		/>
	);
}

export default CartAmountField;
